export default {
  copyright: `Copyright © ${new Date().getFullYear()} 網奕資訊科技 版權所有`,
  logout: "登出",
  productName:'HiTeach心智圖',
  markDownErr:'Markdown格式錯誤',
  markDownNote:'請輸入正確的Markdown格式',
  defaultMind:{
    templateName:'心智圖範本',
    root:'心智圖主題',
    node1:'概念1',
    node2:'概念2',
    node3:'概念3',
    node4:'概念4',
  },
  mainMenu: {
    gotoHome: "前往我的管理頁",
    rename: "重新命名",
    import: "匯入",
    inputMD: "Markdown 檔案",
    pasteMD: "Markdown 文字",
    copyMD: "複製文字",
    export: "匯出",
    downloadMD: "Markdown (.md)",
    downloadImage: "圖片",
    exportStaticMindmap: "發佈展示（靜態心智圖）",
    copyToMyDocuments: "複製到我的文件",
    createCopy: "建立副本",
    alreadyCopied: "已複製到剪貼簿",
    coworkMode:'共用',
    backCollect: "返回收集區",
    deleteMindMap: "刪除心智圖",
  },
  downloadImageSuccess: "圖片已成功下載",
  downloadImageFailed: "下載圖片失敗",
  generateImageFailed: "生成圖片失敗",
  staticMindmap: {
    title: "心智圖主題",
    urlLabel: "私存連結 URL：",
    publicUrlLabel: "公開展示 URL：",
    copied: "URL 已複製到剪貼簿",
    loadFailed: "載入靜態心智圖失敗",
    publishDialogTitle: "發佈展示",
    modePrivate: "私存連結",
    modePrivateDesc: "僅自己使用，不公開",
    modePublic: "公開展示",
    modePublicDesc: "任何人可搜尋瀏覽",
    publishTitle: "展示標題",
    publishDescription: "心智圖簡介（可選填）",
    publishDescriptionPlaceholder: "請輸入文字",
    publishTags: "標籤（逗號分隔）",
    publishBtn: "發布",
    publishing: "發布中...",
    publishSuccess: "已公開展示！可至「公開展示管理」查看或刪除",
    overwriteHint: "將以目前心智圖內容取代 Gallery 中的公開版本",
    overwriteSuccess: "公開展示檔案已存在，已直接更新覆蓋現有的！",
  },
  phoneticFont: {
    loading: "載入注音字體中...",
    loadFailed: "注音字體載入失敗",
  },
  anonymousNameBox: {
    placeholder: "請輸入名字(10字以內)",
    welcomeTitle:'歡迎使用HiTeach雲端心智圖',
    title: "免登快速使用",
    or:'或',
    save: "用此名字",
    loginHint:"登入/申請帳號後使用"
  },
  renameBox:{
    title: "重新命名",
    save: "儲存變更",
  },
  coworkMode: {
    edit: "協作共編",
    view: "唯讀模式",
  },
  mindmapTypeSelection: {
    title: "HiTeach心智圖請選擇",
    localMindmap: "建立本地心智圖",
    cloudMindmap: "取用雲端心智圖",
  },
  unsupportFC:"雲端心智圖目前不支援此功能！",
  auth: {
    notLoggedInShareWarning: "您尚未登入，無法進行分享操作。請先登入後再試。"
  }, 
  initializeFluidRelay:"初始化服務中...請稍候",
  cannotConnect:"無法連接到服務，請檢查網路連線或稍後再試",
  tryingToGetContainer:'讀取資料中...請稍候',
  disconnected:"偵測到與伺服器連線有中斷或其他錯誤, 請檢查網路, 重整頁面再試一次",
  initializeOK:"初始化成功",
  initializeFailed:"初始化失敗, 請檢查網址是否正確，如網址正確內容可能已被擁有者刪除",
  cannotMoveToChild:"不可移動到自己的子節點",
  saveOK:"儲存成功",
  saveFailed:"儲存失敗",
  alreadyDeleted:"心智圖被擁有者刪除，目前已無法使用",
  snapshoting:"截圖中 ~",
  updateSnapshot:"更新截圖",
  relayout:"整理中～",
  tooManyUsers:"目前線上使用者過多，已超過100人，可能會有通訊延遲現象，請稍後再試。",
  userLimitReached:"人數已滿載",

  新增: "新增節點",
  編輯: "編輯節點",
  輸入文字: "輸入文字",
  確定: "確定",
  取消: "取消",
  請先選取節點: "請先選取節點!",
  不可刪除有子項目的節點: "不可刪除有子項目的節點!",
  新增失敗: "新增失敗，上層節點已被刪除!",
  編輯失敗: "編輯失敗，所選節點已被刪除!",
  加入根節點: "加入根節點",
  左邊: "左邊",
  右邊: "右邊",
  已是最上面: "已是最上面!",
  已是最下面: "已是最下面!",
  圖片: "圖片",
  圖片過大提示字1: "所選圖片過大(請小於",
  圖片過大提示字2: "MB)，請重新選擇！",
  連結: "連結",
  連結網址: "連結網址",
  連結名稱: "連結名稱",
  輸入URL: "輸入URL...",
  輸入連結名稱: "輸入連結名稱...",
  註解: "註解",
  進階設定: "進階設定",
  線條顏色: "線條顏色",
  節點顏色: "節點顏色",
  preEditHint: "注意：目前的節點之前編輯者是",
  confirmUpdate: "，確定要修改嗎?",
  moveNodeTitle:'移動節點',
  moveNodeHint:'請選擇上層節點',
  noTopic:'無主題',
  menu:{
    新增:'新增',
    刪除:'刪除',
    上移:'上移',
    下移:'下移',
    左移:'左移',
    右移:'右移',
    編輯:'編輯',
    複製:'複製',
    檢視圖片:'檢視圖片',
    最後更新:'最後更新',
    檢視節點變更記錄:'檢視節點變更記錄',
    lock:'鎖定',
    unlock:'解鎖',
    locked:'已鎖定',
    move:'移動',
    applyColor:'套用色彩',
    applyColorSuccess:'已套用色彩到所有子節點',
    more:'更多',
    allRightLayout:'全向右佈局',
    allRightLayoutSuccess:'已將所有第一層子節點調整為右側佈局',
    allLeftLayout:'全向左佈局',
    allLeftLayoutSuccess:'已將所有第一層子節點調整為左側佈局',
    noChildrenToApply:'根節點沒有子節點可以套用',
    expandAll:'全展開',
    collapseAll:'全收合',
    lockAll:'全鎖定',
    unlockAll:'全不鎖定',
  },
  treeMenu:{
    currentMoveNode:'要移動的節點 (包含子節點)',
    selectedParentNode:'選取為上層節點'
  },
  imgEditor: {
    詢問離開動作: "詢問離開動作?",
    保存圖片: "保存圖片",
    捨棄變更: "捨棄變更",
    取消: "取消",
  },
  mindCollectPage:{
    viewURL:"檢視連結",
    viewEditKey:"檢視編輯密碼",
    deleteMindMap:"刪除心智圖",
    editKey:"編輯密碼：",
    url:"連結：",
    submitMindMap:"繳交任務",
    createRefer:"編輯心智圖範本",
    useTemplate:"運用範本",
    seatNum:"座號",
    name:"姓名",
    inputNum:"輸入數字",
    inputName:"輸入姓名",
    topic:"主題",
    newTopic:"輸入主題",
    searchTopic:"搜尋主題...",
    submitClose:"管理者設置：停止任務收集！",
    viewClose:"管理者設置：不允許點擊觀看內容！",
    templateTips:"Tips: 建立後，可點擊「編輯範本」，繳交者可以此為範本",
    refreshing: "正在重新整理中...",
    refreshSuccess: "重新整理完成",
  },
  mindmapHome:{
    login:'登入',
    logout:'登出',
    logoutOK:'已登出～',
    share:'共用狀態',
    shareShort:'共用',
    delete:'刪除',
    rename:'重新命名',
    detailInfo:'詳細資料',
    copy:'複製',
    renameFile:'重新命名',
    save:'儲存變更',
    haveLinkCanDo:'有連結的人可以',
    closeShare:'停止共用',
    publishShare:'發布共用',
    publishAsAssignmentTemplate:'以此為範本發布任務',
    comfirmDelete:'確定要刪除此心智圖嗎？',
    mindmapCreator:'建立者',
    mindmapEditor:'最後更新者',
    createTime:'建立時間',
    updateTime:'更新時間',
    coworkMode:'共用模式',
    myMindMap:'我建立的',
    myMindMapBtn:'我的心智圖',
    search:'搜尋',
    add:'+ 新增',
    addFile:'私有心智圖',
    addCoworkMindMap:'共編心智圖',
    addMindCollect:'心智圖任務',
    addCollectNormal:'資料夾',
    mindmapName:'名稱',
    noData:'暫無資料',
    true:'是',
    false:'否',
    setCoworkInHTinfo:'於HiTeach內使用時，自動將心智圖文件共用設定為 協作模式 ',
    initialize:'初始化中...請稍候',
    initializeFailed:'初始化失敗',
    deleting:'刪除中...請稍候',
    deletingOKinFront:'刪除成功',
    cannotConnect:'無法連接, 請檢查網路狀態',
    saveOk:'儲存成功',
    saveFailed:'儲存失敗',
    confirmDelete:'刪除確認：',
    mindCollect:{
      share:'設定',
      defaultName:'任務名稱',
      createTitleSetting:'新增心智圖任務',
      openSummitTitle:'開放繳交任務',
      allowViewTitle:'開放觀摩內容',
      colletSetting:'心智圖任務設定',
      updateSetting:'心智圖任務設定',
      confirmDeleteCollectText:'確定要刪除任務嗎? 確認後無法恢復，任務裡的所有心智圖將一併刪除！',
      templateTips:'Tips: 建立後 可點擊「編輯範本」，讓繳交者以此為範本',
    },
    mindCollectNormal:{
      createTitleSetting:'新增資料夾',
      createMindMap:'新增心智圖',
      defaultName:'資料夾名稱',
      colletSetting:'資料夾設定',
      updateSetting:'資料夾設定',
      confirmDeleteCollectText:'確定要刪除資料夾嗎? 確認後無法恢復，資料夾內的所有心智圖將一併刪除！',
    },
    enterShortUrl:'請輸入簡碼來開啟心智圖/任務', 
    cannotOpenShortUrl:'簡碼不存在或已失效～',
    coworkModeNoteText:{
      task:"任務收集",
      viewLongVer:'唯讀檢視',
      editLongVer:'協作共編',
      view:'檢視',
      edit:'共編',
      closeView:'不開放檢視',
    },
    moveToFolder:'移入資料夾',
    moveOutFolder:'移出資料夾',
    noFolder:'暫無數據',
    moveSuccess:'移入成功',
    moveFail:'移入失敗',
    moveOutSuccess:'移出成功',
    moveOutFail:'移出失敗',
    createMindMapTask:'建立心智圖任務',
    taskSuffix:'任務',
    template:'範本',
    refreshClipCode: "重新獲取簡碼",
    clipCodeStillValid: "簡碼已存在尚未到期，無法更新",
    checkClipCodeError: "檢查簡碼時發生錯誤",
    clipCodeRefreshSuccess: "簡碼重新獲取成功",
    clipCodeRefreshError: "重新獲取簡碼失敗",
    clipCodeAutoUpdated: "簡碼太久未使用已主動更新，請留意！",
    gallerySubtitle: "大家都在想什麼？看看其他人怎麼整理知識",
    heroTitle: "今天想整理什麼想法？",
    heroSub: "從模板開始，或從一片空白出發，你決定。",
    galleryHeroStats: "資料庫累積 {count} 份作品",
    galleryLoginBtn: "開始創作",
    galleryTemplatesTitle: "經典{highlight}參考",
    galleryTemplatesHighlight: "範例",
    galleryTemplatesSub: "點開細看，汲取靈感",
    galleryExploreTitle: "探索公開展示",
    gallerySearchPlaceholder: "搜尋心智圖名稱",
    galleryLoading: "載入中...",
    galleryEmpty: "目前還沒有公開的心智圖",
    galleryLoadMore: "載入更多",
    galleryTemplateCards: [
      { title: '學習筆記', sub: '課堂筆記整理' },
      { title: 'Brainstorm', sub: '自由發想' },
      { title: '專案規劃', sub: 'WBS 拆解' },
      { title: '上課重點', sub: '單元架構' },
      { title: '讀書計畫', sub: '學習進度追蹤' },
    ],
  },
   currentUser:'當前使用者',
   privateInfo:'目前心智圖擁有者設定不提供分享，故無法檢視',
   refreshHint:'閒置超過10分鐘無動作，系統已斷開，請重新整理頁面',
   beforeDispoeHint:"偵測10分鐘沒動作，請點擊畫面，否則即將在1分鐘內斷開連線",
   inputEditKey:'輸入編輯密碼',
   sixBit:'6位字元',
   closeMindCollect:'已停止收集', 
   notAllowViewHint: "不允許觀看提交內容，如為編輯者請輸入編輯密碼",
   allowEnterEditSuccess:'編輯密碼驗證成功，允許進入編輯!',
   enterEditKeyWrong:"編輯密碼錯誤，如忘記密碼請在收集區重新提交，或向收集區管理者請求密碼!",
   writeDownEditKey:'請記下你的編輯權密碼，下次開啟需輸入編輯密碼才可編輯:',
   reachMaxOpenFRUsage:'目前分享文件的使用量已達上限，因此無法新增。',
   fluidRelayUsage:'分享文件用量：',
   recentClick:'最近點閱',
   publicDisplay:'我的公開展示',
   publicDeleteConfirm:'刪除後無法復原，需重新發佈，確定刪除嗎？',
   owner:'所有者：',
   linkShareSuccess:'心智圖連結已成功推送',
   linkShareCooldown:'請稍候1分鐘再推送心智圖連結',
   mindCollectLinkShareSuccess:'心智圖任務連結已成功推送',
   mindCollectLinkShareCooldown:'請稍候1分鐘再推送心智圖任務連結',
  qrcodeTitle: '掃描 QR Code',
  qrcodeGenerateFailed: '生成 QR Code 失敗',
  copyToMine: {
    title: '儲存你的心智圖',
    btn: '儲存成我的心智圖',
    loginRequired: '登入後即可',
    benefit1: '保存你的編輯',
    benefit2: '隨時繼續',
    benefit3: '分享與多人協作',
    goLogin: '前往登入',
    cancel: '取消',
    success: '已儲存到我的心智圖!',
    failed: '儲存失敗，請稍後再試',
    copyLabel: '副本',
  },
  playground: {
    title: '遊樂場',
    homeBtn: '回首頁',
    mindRoot: '自由創作',
    mindNode1: '好奇探索',
    mindNode1a: '無限可能',
    mindNode2: '智慧學習',
    mindNode2a: '每日一記',
    mindNode3: '悠閒創作',
    mindNode3a: '色彩繽紛',
    mindNode3b: '隨手塗鴉',
    mindNode4: '快速行動',
    mindNode4a: '馬上開始',
  },
};
